module.exports = __webpack_public_path__ + "img/shuaige.9c021ffb.png";